import React from 'react';
import { RandomCssDemo } from './RandomCssDemo';
import { makePolaroids } from './utils';
import POLAROID_1 from './polaroids/christoffer-engstrom-wc9avd2RaN0-unsplash.jpg';
import POLAROID_2 from './polaroids/conor-sexton-hRemch0ZDwI-unsplash.jpg';
import POLAROID_3 from './polaroids/cristian-palmer-XexawgzYOBc-unsplash.jpg';
import POLAROID_4 from './polaroids/giga-khurtsilava-5kwVYW8ZIHo-unsplash.jpg';
import POLAROID_5 from './polaroids/joseph-barrientos-oQl0eVYd_n8-unsplash.jpg';
import POLAROID_6 from './polaroids/matt-hardy-6ArTTluciuA-unsplash.jpg';
import POLAROID_7 from './polaroids/shifaaz-shamoon-sLAk1guBG90-unsplash.jpg';
import POLAROID_8 from './polaroids/silas-baisch-K785Da4A_JA-unsplash.jpg';
import POLAROID_9 from './polaroids/thomas-vimare-IZ01rjX0XQA-unsplash.jpg';

const POLAROID_HTML = `<form>
  <button type="reset">Stack them back up</button>
  ${makePolaroids(9)}
</form>`;

const POLAROID_HTML_SIMPLE = `<form>
  ${makePolaroids(9, false)}
</form>`;

const POLAROID_SCAFFOLD = `
  * { box-sizing: border-box; }
  :root {
    --photo-1: url("${POLAROID_1}");
    --photo-2: url("${POLAROID_2}");
    --photo-3: url("${POLAROID_3}");
    --photo-4: url("${POLAROID_4}");
    --photo-5: url("${POLAROID_5}");
    --photo-6: url("${POLAROID_6}");
    --photo-7: url("${POLAROID_7}");
    --photo-8: url("${POLAROID_8}");
    --photo-9: url("${POLAROID_9}");
  }
  html { overflow: hidden; }
  body {
    margin: 0;
    min-height: 100vh;
    background: #e9e0cb;
    font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif;
  }

  form {
    position: absolute;
    inset: 0;
    display: grid;
    place-items: center;
  }

  form > button {
  grid-area: 1 / 1 / 2 / 2;
  align-self: center;
  justify-self: center;
  padding: 5px 10px;
  border-radius: 3px;
  border: none;
  background: #f9f0db;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  transition:
    scale 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;

  &:active {
    scale: 0.95;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  }
}

  .polaroid .img {
    position: relative;
    width: 100%;
    aspect-ratio: 1 / 1;
    overflow: hidden;
    background: #121212;
  }

  .polaroid .img::before {
    content: '';
    position: absolute;
    inset: 0;
    background: var(--photo);
    background-size: cover;
    background-position: center;
  }

  .polaroid:nth-last-child(1) { --photo: var(--photo-1); }
  .polaroid:nth-last-child(2) { --photo: var(--photo-2); }
  .polaroid:nth-last-child(3) { --photo: var(--photo-3); }
  .polaroid:nth-last-child(4) { --photo: var(--photo-4); }
  .polaroid:nth-last-child(5) { --photo: var(--photo-5); }
  .polaroid:nth-last-child(6) { --photo: var(--photo-6); }
  .polaroid:nth-last-child(7) { --photo: var(--photo-7); }
  .polaroid:nth-last-child(8) { --photo: var(--photo-8); }
  .polaroid:nth-last-child(9) { --photo: var(--photo-9); }
`;

const POLAROID_SCAFFOLD2 = `
  ${POLAROID_SCAFFOLD}
  .polaroid {
    grid-area: 1 / 1 / 2 / 2;
    position: relative;
    background: #f9f0db;
    border-radius: 3px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    width: min(300px, 70vw);
    aspect-ratio: 2.1 / 2.5;
    padding: 15px;
    transform:
      rotate(random(-15deg, 15deg))
      translate(random(-10px, 10px), random(-10px, 10px));

    input {
      position: absolute;
      inset: 0;
      width:100%;
      height:100%;
      opacity: 0;
      cursor: pointer;
    }
  }
      `;

export function PolaroidsStackExample() {
  return (
    <RandomCssDemo
      title="Polaroids: Randomized Stack"
      htmlBody={POLAROID_HTML_SIMPLE}
      scaffoldCss={POLAROID_SCAFFOLD}
      showLoadButton={false}
      cssCodeInit={`.polaroid {
    grid-area: 1 / 1 / 2 / 2;
    position: relative;
    background: #f9f0db;
    border-radius: 3px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    width: min(400px, 82vw);
    aspect-ratio: 2.1 / 2.5;
    padding: 25px;
    transform:
      rotate(random(-15deg, 15deg))
      translate(random(-10px, 10px), random(-10px, 10px));
}`}
    />
  );
}

export function PolaroidsInteractiveExample() {
  return (
    <RandomCssDemo
      title="Polaroids: Click to Fling"
      htmlBody={POLAROID_HTML}
      showLoadButton={false}
      scaffoldCss={POLAROID_SCAFFOLD2}
      cssCodeInit={`.polaroid {
    transition: transform 0.33s ease-in-out;

    &:has(input:checked) {
      pointer-events:none;
      transform:
      translate(random(-50vw, 50vw), -70vh)
      rotate(random(-120deg, 120deg));
    }

    &:has(input:active) {
      transform: scale(1.2);
    }
  }`}
    />
  );
}
